<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>订单详情</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_goBack">
          <i class="el-icon-close"></i> 返回
        </el-button>
      </div>
      <el-row :gutter="20" class="text-left">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">订单编码：</label>
            <span>{{ storeOrderCartDetailInfo.orderId }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">总金额:</label>
            <span>{{ storeOrderCartDetailInfo.payPrice }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">下单时间:</label>
            <span>{{ storeOrderCartDetailInfo.createTime }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">用户:</label>
            <span>{{ storeOrderCartDetailInfo.personName }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="text-left">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">是否分账:</label>
            <span>{{ storeOrderCartDetailInfo.profitSharing == 'N' ? '否' : '是' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">平台:</label>
            <span>{{ storeOrderCartDetailInfo.appName }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
      </div>
      <el-table :data="storeOrderCartDetailInfo.storeOrderCarts" border style="width: 100%">
        <el-table-column prop="coverPhoto" label="商品图片" align="center" width="120">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px; border-radius: 10px;" :src="scope.row.coverPhoto"
              :preview-src-list="[scope.row.coverPhoto]" fit="cover">
              <div slot="error" class="image-slot">
                <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px; border-radius: 10px;">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prodName" label="商品名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.prodName }}({{ scope.row.specValue }})
          </template>
        </el-table-column>
        <el-table-column prop="productId" label="商品编号" align="center"></el-table-column>
        <el-table-column prop="cartNum" label="数量" align="center"></el-table-column>
        <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
        <el-table-column prop="createTime" label="支付时间" align="center"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>费用信息</span>
      </div>
      <el-table :data="storeOrderCartDetailInfo.storeOrderCartFees" border style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column prop="feeName" label="费用名称" align="center"></el-table-column>
        <el-table-column prop="price" label="金额" align="center"></el-table-column>
        <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="payWayName" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="state" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.state == '1001' ? '未支付' : '已支付' }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="支付时间" align="center"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>分账信息</span>
      </div>
      <el-table :data="storeOrderCartDetailInfo.ledgers" border style="width: 100%">
        <el-table-column prop="storeName" label="商户" align="center"></el-table-column>
        <el-table-column prop="feeSpecCd" label="规格" align="center">
          <template slot-scope="scope">
            {{ getFeeSpecName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="分账金额" align="center"></el-table-column>
        <el-table-column prop="saveType" label="充值" align="center">
          <template slot-scope="scope">
            {{ getFeeSaveTypeName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="saveObjId" label="对象编号" align="center"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" v-if="storeOrderCartDetailInfo.storeOrderDiscounts && storeOrderCartDetailInfo.storeOrderDiscounts.length > 0">
      <div slot="header" class="flex justify-between">
        <span>优惠信息</span>
      </div>
      <el-table :data="storeOrderCartDetailInfo.storeOrderDiscounts" border style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column prop="discountTypeName" label="优惠方式" align="center"></el-table-column>
        <el-table-column prop="discountPrice" label="优惠金额" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.discountType == '2002'">{{ scope.row.discountPrice }}</span>
            <span v-else>{{ scope.row.discountPrice }}({{ scope.row.discountRate }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="说明" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" v-if="storeOrderCartDetailInfo.appId != '992021030901240071'">
      <div slot="header" class="flex justify-between">
        <span>收货人信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">用户名称：</label>
            <span>{{ storeOrderCartDetailInfo.addressInfo.username }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">手机号码:</label>
            <span>{{ storeOrderCartDetailInfo.addressInfo.tel }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">收货地址:</label>
            <span>{{ storeOrderCartDetailInfo.addressInfo.address }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">备注:</label>
            <span>{{ storeOrderCartDetailInfo.remark }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>操作信息</span>
      </div>
      <el-table :data="storeOrderCartDetailInfo.events" border style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column prop="createTime" label="操作时间" align="center" width="200"></el-table-column>
        <el-table-column prop="eventMsg" label="说明" align="center"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {
  queryStoreOrder,
  queryStoreOrderCart,
  queryStoreOrderAddress,
  queryOrderEvent,
  queryStoreOrderDiscount,
  listStoreOrderLedgerAcct,
  queryStoreOrderCartFee
} from '@/api/goods/storeOrderCartDetail/storeOrderCartDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'StoreOrderCartDetail',
  data() {
    return {
      storeOrderCartDetailInfo: {
        orderId: '',
        appId: '',
        appName: '',
        deduction: '',
        personName: '',
        stateName: '',
        profitSharing: '',
        payPrice: '',
        createTime: '',
        addressInfo: {
          username: '',
          tel: '',
          address: ''
        },
        remark: '',
        storeOrderCarts: [],
        storeOrderCartFees: [],
        events: [],
        storeOrderDiscounts: [],
        ledgers: []
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this.storeOrderCartDetailInfo.orderId = this.$route.query.orderId
    this._loadStoreOrder()
    this._listOrderCart()
    this._listOrderAddress()
    this._listOrderCartEvent()
    this._listStoreOrderCartFees()
    this._listOrderDiscount()
    this._ledgers()
  },
  methods: {
    async _loadStoreOrder() {
      try {
        const res = await queryStoreOrder({
          page: 1,
          row: 1,
          orderId: this.storeOrderCartDetailInfo.orderId
        })
        Object.assign(this.storeOrderCartDetailInfo, res.data[0])
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listOrderCart() {
      try {
        const res = await queryStoreOrderCart({
          page: 1,
          row: 100,
          orderId: this.storeOrderCartDetailInfo.orderId,
          shopId: this.shopId
        })
        res.data.forEach(orderCart => {
          if (orderCart.productSpecDetails) {
            let specValue = ''
            orderCart.productSpecDetails.forEach(detail => {
              specValue += (detail.detailValue + "/")
            })
            orderCart.specValue = specValue
          }
        })
        this.storeOrderCartDetailInfo.storeOrderCarts = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listOrderAddress() {
      try {
        const res = await queryStoreOrderAddress({
          page: 1,
          row: 1,
          orderId: this.storeOrderCartDetailInfo.orderId,
          shopId: this.shopId
        })
        if (res.data[0] && res.data.length > 0) {
          Object.assign(this.storeOrderCartDetailInfo.addressInfo, res.data[0])
        }
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listOrderCartEvent() {
      try {
        const res = await queryOrderEvent({
          page: 1,
          row: 50,
          orderId: this.storeOrderCartDetailInfo.orderId,
          shopId: this.shopId
        })
        this.storeOrderCartDetailInfo.events = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listOrderDiscount() {
      try {
        const res = await queryStoreOrderDiscount({
          page: 1,
          row: 50,
          shopId: this.shopId,
          orderId: this.storeOrderCartDetailInfo.orderId
        })
        this.storeOrderCartDetailInfo.storeOrderDiscounts = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _ledgers() {
      try {
        const res = await listStoreOrderLedgerAcct({
          page: 1,
          row: 50,
          shopId: this.shopId,
          orderId: this.storeOrderCartDetailInfo.orderId
        })
        this.storeOrderCartDetailInfo.ledgers = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listStoreOrderCartFees() {
      try {
        const res = await queryStoreOrderCartFee({
          page: 1,
          row: 50,
          orderId: this.storeOrderCartDetailInfo.orderId,
          shopId: this.shopId
        })
        this.storeOrderCartDetailInfo.storeOrderCartFees = res.data
        console.log(this.storeOrderCartDetailInfo.storeOrderCartFees)
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _goBack() {
      this.$router.go(-1)
    },
    getFeeSpecName(item) {
      if (item.feeSpecCd == '1001') {
        return '服务费'
      }
      if (item.feeSpecCd == '2002') {
        return '折扣金'
      }
      if (item.feeSpecCd == '3003') {
        return '商品金'
      }
      return '未知'
    },
    getFeeSaveTypeName(item) {
      if (item.saveType == '45') {
        return '账户充值'
      }
      if (item.saveType == '55') {
        return '优惠券'
      }
      return '未知'
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 18px;
}

.form-label {
  margin-right: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>